import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';
import { useSettings } from '../context/SettingsContext';

export default function Home() {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const { data: pills, loading } = usePublicList('pills');
  const leftPills = pills.filter((p) => p.side === 'left').sort((a, b) => a.order - b.order);
  const rightPills = pills.filter((p) => p.side === 'right').sort((a, b) => a.order - b.order);

  // Fallback content if API fails
  const fallbackLeft = [
    { id: 'f1', label: 'Haqqımda', order: 1 },
    { id: 'f2', label: 'Xidmətlər', order: 2 },
  ];
  const fallbackRight = [
    { id: 'f3', label: 'Layihələr', order: 1 },
    { id: 'f4', label: 'Əlaqə', order: 2 },
  ];

  const displayLeft = leftPills.length > 0 ? leftPills : fallbackLeft;
  const displayRight = rightPills.length > 0 ? rightPills : fallbackRight;

  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-side">
          {displayLeft.map((p) => (
            <button 
              key={p.id} 
              className="pill" 
              onClick={() => {
                if (p.label === 'Haqqımda') navigate('/haqqimda');
                else if (p.label === 'Xidmətlər') navigate('/xidmetler');
                else if (p.label === 'Layihələr') navigate('/layiheler');
                else if (p.label === 'Əlaqə') navigate('/elaqe');
                else navigate(`/pills/${p.id}`);
              }}
            >
              {p.label}
            </button>
          ))}
        </div>
        <div className="hero-photo">
          <img src={settings.hero_person_image} alt={settings.brand_name} />
        </div>
        <div className="hero-side right">
          {displayRight.map((p) => (
            <button 
              key={p.id} 
              className="pill" 
              onClick={() => {
                if (p.label === 'Haqqımda') navigate('/haqqimda');
                else if (p.label === 'Xidmətlər') navigate('/xidmetler');
                else if (p.label === 'Layihələr') navigate('/layiheler');
                else if (p.label === 'Əlaqə') navigate('/elaqe');
                else navigate(`/pills/${p.id}`);
              }}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
